import Link from "next/link";

import { SearchIcon } from "shared/providers/Layout/components/NewTopBar/assets/SearchIcon";
import { useFeature } from "shared/utils/hooks/useFeature";

import { SearchButtonContainer } from "./styles";

export const SearchButton = () => {
  const isSearchEnabled = useFeature("f_search");

  if (!isSearchEnabled) return null;
  return (
    <Link href="/search" className="search" prefetch={false}>
      <SearchButtonContainer>
        <SearchIcon />
      </SearchButtonContainer>
    </Link>
  );
};
